import script from "./PasswordRecovery.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordRecovery.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=ed6e37fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed6e37fa"]])

export default __exports__